"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingTypeEnum = void 0;
var MatchingTypeEnum;
(function (MatchingTypeEnum) {
    MatchingTypeEnum[MatchingTypeEnum["AUTO_MATCHED"] = 1] = "AUTO_MATCHED";
    MatchingTypeEnum[MatchingTypeEnum["AUTO_UNMATCHED"] = 2] = "AUTO_UNMATCHED";
    MatchingTypeEnum[MatchingTypeEnum["MANUAL_MATCHED"] = 3] = "MANUAL_MATCHED";
    MatchingTypeEnum[MatchingTypeEnum["MANUAL_REVIEW"] = 4] = "MANUAL_REVIEW";
    MatchingTypeEnum[MatchingTypeEnum["NONE"] = 5] = "NONE";
    MatchingTypeEnum[MatchingTypeEnum["TO_CREATE"] = 6] = "TO_CREATE";
})(MatchingTypeEnum || (exports.MatchingTypeEnum = MatchingTypeEnum = {}));
